import axios from '@/config/axios';

const TRENDING_CACHE_KEY = 'trending_cache';
const TRENDING_CACHE_TTL = 60 * 60 * 1000; // 1 hour in ms

const DB_NAME = 'BookAppDB';
const DB_VERSION = 2; // Tăng lên 2 để đồng bộ với recommendCache
const STORE_NAME = 'trending_cache';

export function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      // Tạo store trending_cache nếu chưa có
      if (!db.objectStoreNames.contains('trending_cache')) {
        db.createObjectStore('trending_cache');
      }
      // Tạo store recommend_cache nếu chưa có (dùng chung DB)
      if (!db.objectStoreNames.contains('recommend_cache')) {
        db.createObjectStore('recommend_cache');
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function saveTrendingToCache(data) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const request = store.put({ data: data, timestamp: Date.now() }, TRENDING_CACHE_KEY);

      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (e) {
    console.error('Lỗi khi lưu cache Trending vào IndexedDB:', e);
  }
}

export async function loadTrendingFromCache() {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const request = store.get(TRENDING_CACHE_KEY);

      request.onsuccess = () => {
        const cached = request.result;
        if (!cached || !cached.data || !cached.timestamp) {
          resolve(null);
          return;
        }
        if (Date.now() - cached.timestamp >= TRENDING_CACHE_TTL) {
          clearTrendingCache();
          resolve(null);
          return;
        }
        resolve(cached.data);
      };
      request.onerror = () => reject(request.error);
    });
  } catch (e) {
    console.error('Lỗi khi đọc cache Trending từ IndexedDB:', e);
    return null;
  }
}

export async function clearTrendingCache() {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const request = store.delete(TRENDING_CACHE_KEY);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (e) {
    console.error('Lỗi khi xóa cache Trending trong IndexedDB:', e);
  }
}

/**
 * Checks if the specified bookId is in the trending cache.
 * If yes, calls the API to fetch the latest trending data and updates the cache silently.
 */
export async function updateTrendingCacheIfBookExists(bookId) {
  try {
    const cachedData = await loadTrendingFromCache();
    if (!cachedData) return;

    const bookExists = cachedData.some(book => book.id == bookId);
    if (bookExists) {
      console.log(`[Cache] Sách ${bookId} có trong IndexedDB. Đang xóa cache và gọi lại API GET /book/v1/trending...`);
      
      // Xóa cache cũ
      await clearTrendingCache();
      
      // Gọi lại API không truyền param
      const res = await axios.get('/book/v1/trending');
      
      if (res && res.data && res.data.status === '200' && res.data.result) {
        const all = Array.isArray(res.data.result) ? res.data.result : [];
        // Lưu lại dữ liệu mới vào IndexedDB
        await saveTrendingToCache(all);
        console.log(`[Cache] Đã làm mới cache trending thành công.`);
        
        // Báo cho Home biết để cập nhật giao diện
        window.dispatchEvent(new CustomEvent('trending-cache-updated-silently'));
      }
    } else {
      console.log(`[Cache] Sách ${bookId} KHÔNG có trong IndexedDB. Bỏ qua việc gọi API.`);
    }
  } catch (e) {
    console.error('Lỗi khi updateTrendingCacheIfBookExists:', e);
  }
}
